import React, { useRef, useCallback, } from 'react'
import List from '../../grid.component';
import { AddresssHandler, AmountHandler, CreditHandler, DateHandler, TransactionHash } from '../service';


const TopUpTransactionsGrid = ((props) => {
    const gridRef = useRef(null);

    const handleHash = useCallback((data) => () => {
        window.open(data.url)
    }, [])
    const topupTransactionHandler = useCallback((data) => {
        return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
    }, [])
    const addressHandler = useCallback((data) => {
        return <AddresssHandler data={data?.dataItem} />
    }, [])
    const creditHandler = useCallback((data) => {
        return <CreditHandler data={data?.dataItem} />
    }, [])
    const dateHandler = useCallback((data) => {
        return <DateHandler data={data?.dataItem} />
    }, [])
    const amountHandler = useCallback((data) => {
        return <AmountHandler data={data?.dataItem} />
    }, [])
    const customcells = {
        "transactionhash": topupTransactionHandler,
        "address": addressHandler,
        "credits": creditHandler,
        "date": dateHandler,
        "amount": amountHandler
    };
    const renderCustomCell = useCallback((props, column) => {
        if (customcells[column.field]) {
            return customcells[column.field](props);
        }
    }, [customcells])

    return (
        <div>
            <List
                url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/Topupk`}
                additionalParams={props?.filterValues}
                pSize={10}
                className="custom-grid"
                ref={gridRef}
                showExcelExport={props?.isExcelExport}
                pKey={"Energy_TopUp_Transactions"}
                screenName={'Energy_TopUp_Transactions'}
                renderCustomCell={renderCustomCell}
            />
        </div>
    )
})

export default React.memo(TopUpTransactionsGrid)
